import Toaster from './Toaster.jsx'
import './Toaster.less'

export default Toaster
